import React, {useState, useCallback,  }  from "react";
import { makeStyles } from "@material-ui/styles";

import Draggable from 'react-draggable'; // The default
import { Button, Tooltip} from '@material-ui/core';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography'

import styles from '../utils/mystyle.module.css'

import CustomizedRadios from './ViewMenuRadio'
import { useEffect } from "react";
import Materials from '../collections/materials'
  
import  Perf  from '../static/Icons/perf.png'
import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight';



const useStyles = makeStyles(theme => ({
  popover: {
    pointerEvents: 'none',
  },
  popoverContent: {
    pointerEvents: 'auto',
  },
}));

const Board = (props) =>{
  const [mounted, setMounted] = useState(false);
  const {asyncLogParams} = props

  let boardWidth = (window.innerWidth /3) - ((window.innerWidth /3) /23)
  let boardHeight = ((boardWidth*5)/4.2 ) 

  const sevenH = boardHeight * .1 // 75
  const sixH = boardHeight * .86 // 620
  const fourH = boardHeight * .55 // 400
  const oneH = boardHeight * .14 // 100

  const sevenW = boardWidth * .12 // 75
  const fiveW = boardWidth * .72 // 500
  const threeW = boardWidth * .49 // 300
  const twoW = boardWidth * .41 // 200

  const boardStyles = {
    1: {
    zprim: {height: 'auto', width: '14rem', objectFit: 'cover', objectPosition: 'center'},
    zsec: {height: 'auto', width: '12rem', objectFit: 'cover', objectPosition: 'center'},  
    wood: {height: fourH, width: threeW*1.2, objectFit: 'cover', objectPosition: '50% 20%' },  
    nature: {height: '22rem', width: 'auto', objectFit: 'cover', objectPosition: 'center'}, 
    tile: {height: oneH*1.5, width: 'auto', objectFit: 'cover', objectPosition: 'center'},  
    industrial: {height: sevenH, width: sevenW, objectFit: 'cover', objectPosition: 'center'},
  },
  2: {
    zprim: {height: 'auto', width: '14rem', objectFit: 'cover', objectPosition: 'center'},
    zsec: {height: 'auto', width: '12rem', objectFit: 'cover', objectPosition: 'center'},  
    wood: {height: sixH, width: fiveW, objectFit: 'cover', objectPosition: '50% 20%' },  
    nature: {height: '22rem', width: 'auto', objectFit: 'cover', objectPosition: 'center'},  
    tile: {height: oneH, width: threeW, objectFit: 'cover', objectPosition: 'center'},  
    industrial: {height: sevenH, width: twoW, objectFit: 'cover', objectPosition: 'center'},
  },
  3: {
    zprim: {height: 'auto', width: '14rem', objectFit: 'cover', objectPosition: 'center'},
    zsec: {height: 'auto', width: '12rem', objectFit: 'cover', objectPosition: 'center'},  

    wood: {height: sixH, width: fiveW, objectFit: 'cover', objectPosition: '50% 20%' },  
    nature: {height: '22rem', width: 'auto', objectFit: 'cover', objectPosition: 'center'}, 
    tile: {height: oneH, width: threeW, objectFit: 'cover', objectPosition: 'center'},  
    industrial: {height: sevenH, width: twoW, objectFit: 'cover', objectPosition: 'center'},
  },
  }
  
 

  const boardLayout =  {
    1:{
    zPrim: {x: (boardWidth*.32), y: (boardHeight*.14)},
    zsec: {x: (boardWidth*.24), y: (boardHeight*.43)},
    wood: {x: (boardWidth*.16), y:(boardHeight*.34)},
    nature: {x: (boardWidth*.1), y: (boardHeight*.65)},
    tile: {x: (boardWidth*.57), y: (boardHeight*.62)},
    industrial: {x: boardWidth*.1, y: (boardHeight*.44)},
  },
  2:{
    zPrim: {x: (boardWidth*.3), y: (boardHeight*.41)},
    zsec: {x: (boardWidth*.49), y: (boardHeight*.21)},
    wood: {x: (boardWidth*.25), y: 0},
    nature: {x: (boardWidth*.35), y: (boardHeight*.61)},
    tile: {x: (boardWidth*.41), y: (boardHeight*.62)},
    industrial: {x: (boardWidth*.20), y: (boardHeight*.34)},
  },
  3:{
    zPrim: {x: (boardWidth*.16), y: (boardHeight*.08)},
    zsec: {x: (boardWidth*.36), y: (boardHeight*.30)},
    wood: {x: (boardWidth*.16), y:(boardHeight*.34)},
    nature: {x: (5), y: (boardHeight*.66)},
    tile: {x: (boardWidth*.6), y: (boardHeight*.6)},
    industrial: {x: (-boardWidth*.10), y: (boardHeight*.54)},
  },
  }

  const materialFunc = () => {

    const valkey = Object.values(props.material).map(val => Materials.filter(v => v.name === val)[0].imageUrl.default)
    const name = Object.values(props.material).map(val => Materials.filter(v => v.name === val)[0].name)

    return {valkey, name}
  };

  const [state, setState] = useState({
    activeDrags: 0,
    deltaPosition: {
      x: 0, y: 0
    },
    controlledPositionZ1: {
    x: 0, y: 0
    },
    controlledPositionZ2: {
    x: 0, y: 0
    },
    controlledPositionW: {
    x: 0, y: 0
    },
    controlledPositionN: {
    x: 0, y: 0
    },
    controlledPositionT: {
    x: 0, y: 0
    },
    controlledPositionI: {
    x: 0, y: 0
    }
    
    })

    const [viewIndex, setViewIndex] = useState(2)


    

    // console.log("prime ", state.controlledPosition)
    
    


    // portion for drag
    const onStart = () => {
      console.log("onstart")
      setState({activeDrags: ++state.activeDrags});
    };
    
    const onStop = () => {
      setState({activeDrags: --state.activeDrags});
    };
    
    const onControlledDragStopZ1 = (e, position) => {
      const {x, y} = position;
      setState({controlledPositionZ1: {x, y}});
      onStop();
    };
    const onControlledDragStopZ2 = (e, position) => {
      const {x, y} = position;
      setState({controlledPositionZ2: {x, y}});
      onStop();
    };
    const onControlledDragStopW = (e, position) => {
      const {x, y} = position;
      setState({controlledPositionW: {x, y}});
      onStop();
    };
    const onControlledDragStopN = (e, position) => {
      const {x, y} = position;
      setState({controlledPositionN: {x, y}});
      onStop();
    };
    const onControlledDragStopT = (e, position) => {
      const {x, y} = position;
      setState({controlledPositionT: {x, y}});
      onStop();
    };
    const onControlledDragStopI = (e, position) => {
      const {x, y} = position;
      setState({controlledPositionI: {x, y}});
      onStop();
    };

    const dragHandlers = {onStart: onStart, onStop: onStop, };
    const materialSel = materialFunc()
    
    const setupControlls = () => {
      setState(prev => ({...prev, 
        controlledPositionZ1: {x: 106.365, y: 173.055},  
        controlledPositionZ2: {x: 173.73,y:88.6377},
        controlledPositionW: {x: 88.6377, y: 0}, 
        controlledPositionN: {x: 124.093, y: 257.471}, 
        controlledPositionT: {x: 145.366, y: 261.692}, 
        controlledPositionI: {x: 70.9101, y: 143.509}, 
        }))
      }
    //first load
    window.onload = setupControlls
  
    
    useEffect(() => {
        setState(prev => ({...prev, 
          controlledPositionZ1: boardLayout[viewIndex].zPrim,
          controlledPositionZ2: boardLayout[viewIndex].zsec,
          controlledPositionW: boardLayout[viewIndex].wood,
          controlledPositionN: boardLayout[viewIndex].nature,
          controlledPositionT: boardLayout[viewIndex].tile,
          controlledPositionI: boardLayout[viewIndex].industrial,
          }))

          if (mounted){
            asyncLogParams("Board scene", viewIndex)
          } else {
              setMounted(true)
          }

    }, [viewIndex])

    //not sure about using this ?
    // const zprimposition = useCallback (() => {
    //     setState(prev => ({...prev, 
    //       controlledPositionZ1: boardLayout[viewIndex].zPrim,
    //       controlledPositionZ2: boardLayout[viewIndex].zsec,
    //       controlledPositionW: boardLayout[viewIndex].wood,
    //       controlledPositionN: boardLayout[viewIndex].nature,
    //       controlledPositionT: boardLayout[viewIndex].tile,
    //       controlledPositionI: boardLayout[viewIndex].industrial,
    //       }))
    // }, [ viewIndex])

    const MaskImage = ({children, }) => (

        <div style={{
          width: '100%',
          WebkitMaskImage: `url(${Perf})`,
          WebkitMaskSize: "100%",
        }}
        >
          {children}
        </div>
        
  )

        
  // -------- popover

  const [anchorEl, setAnchorEl] = useState(null);
  const [perfState, setPerfState] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const classes = useStyles();

  // --- switch perf
  const handleOnClick = () => {
    asyncLogParams("PerfState", 1)
    setPerfState(!perfState)
  }

      return (
        
        <div  style={{height: '100%', width: '100%', display: 'inline-block', position: 'relative', overflow: 'hidden', background: "#e4e4e4", padding: '5', }}>
        <div
        >
        
        <Draggable  {...dragHandlers} position={state.controlledPositionZ1} onStop={onControlledDragStopZ1} >
          <div style={{ position: 'absolute', zIndex: '7', display: 'flex',  }}
          >
            <div className={styles.reactdraggable} style={{ filter: 'drop-shadow(15px 20px 4px rgba(50, 50, 50, .4))', display: 'flex',}}

            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            id={perfState ? 'mask' : 'noMask'}
            onMouseEnter={handlePopoverOpen} //this is the location that seems to work best
            onMouseLeave={handlePopoverClose}
            >
              
              
                {perfState?
                  
                  <MaskImage  >
                    <img 
                    draggable="false"
                    src={materialSel.valkey[0]}  
                    style={boardStyles[viewIndex].zprim}
                    onClick={() => setState({tooltipZ2: false})}
                    alt="zahner 1"
                    />
                  </MaskImage>
                  :
                    <img 
                    draggable="false"
                    src={materialSel.valkey[0]}  
                    style={boardStyles[viewIndex].zprim}
                    onClick={() => setState({tooltipZ2: false})}
                    alt="zahner 1"

                    id="popover"
                    />
                    
                }
                
                {/* </div> */}
                <div >
                  <Popover
                  id="mouse-over-popover"
                  className={classes.popover}
                  classes={{
                    paper: classes.popoverContent,
                  }}
                  transitionDuration='auto'//{11}
                  open={open}
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                  }}
                  PaperProps={{
                    style: { width: '150px',
                    minWidth: '75px',
                  background:'#696969', },
                  onMouseEnter: handlePopoverOpen, 
                  onMouseLeave: handlePopoverClose
                  }}
                >
                  <Typography sx={{ ml: 1 }}
                  style={{
                    marginLeft: '5%',
                    color: "white",
                    fontSize: '.75rem',
                  }}
                  >{materialSel.name[0]} 
                  </Typography>


                   <Button 
                  color="secondary"
                  style={{
                    marginLeft: '5%',
                    marginBottom: '5%',
                    maxWidth: "105px",
                    maxHeight: "50px",
                    minWidth: "30px",
                    minHeight: "30px",
                    fontSize: '.75rem',
                    backgroundColor: '#696969',
                  }}
                  
                  size="small" 
                  onClick={handleOnClick}
                  > <SubdirectoryArrowRightIcon/> Toggle Perf</Button>
                </Popover>
              </div>

            </div>
          </div>
        </Draggable>

        <Draggable   {...dragHandlers}  position={state.controlledPositionZ2} onStop={onControlledDragStopZ2}>
          <div style={{ position: 'absolute', zIndex: '6' }}>
            <div className={styles.reactdraggable} style={{ filter: 'drop-shadow(5px 5px 2px rgba(50, 50, 50, .2))'}} >
            <Tooltip 
            title={materialSel.name[1]} 
            placement="left"
            disableFocusListener 
            disableTouchListener
            >
              
              <img 
                src={materialSel.valkey[1]}  
                style={boardStyles[viewIndex].zsec}
                draggable="false"
                onClick={() => setState({tooltipZ2: false})}
                alt="zahner 2"
                onMouseEnter={handlePopoverClose}
                />
            </Tooltip>
            </div>
          </div>
        </Draggable>

        <Draggable   {...dragHandlers} position={state.controlledPositionW} onStop={onControlledDragStopW}> 
        <div style={{ position: 'absolute', zIndex: '1' }}>

          <div className={styles.reactdraggable} style={{ filter: 'drop-shadow(10px 10px 4px rgba(50, 50, 50, .4))'}}>
            
          <Tooltip 
            title={materialSel.name[2]} 
            placement="left"
            disableFocusListener 
            disableTouchListener
            >
              <img 
              src={materialSel.valkey[2]}  
              style={boardStyles[viewIndex].wood}
              width="150"
              draggable="false"
              onClick={() => setState({tooltipWood: false})}
              alt="wood"
              />
            </Tooltip>
            
          </div>
          
        </div>
        </Draggable>


        <Draggable  {...dragHandlers} position={state.controlledPositionN} onStop={onControlledDragStopN}> 
        <div style={{ position: 'absolute', zIndex: '10' }}>

          <div className={styles.reactdraggable} style={{ filter: 'drop-shadow(5px 5px 4px rgba(50, 50, 50, .4))'}} 
          >
          <Tooltip 
            title={materialSel.name[3]} 
            placement="left"
            disableFocusListener 
            disableTouchListener
            >

              <img 
              src={materialSel.valkey[3]}  
              style={boardStyles[viewIndex].nature}
              draggable="false"
              onClick={() => setState({tooltipNature: false})}
              alt="nature"
              />
            </Tooltip>
            
          </div>
          
        </div>
        </Draggable>
        
        <Draggable {...dragHandlers} position={state.controlledPositionT} onStop={onControlledDragStopT} > 
        <div style={{ position: 'absolute', zIndex: '9' }}>
          <div className={styles.reactdraggable} style={{ filter: 'drop-shadow(10px 10px 4px rgba(50, 50, 50, .3))'}}  
          >
          <Tooltip 
            title={materialSel.name[4]} 
            placement="left"
            disableFocusListener 
            disableTouchListener
            >
              <img 
              src={materialSel.valkey[4]}  
              style={boardStyles[viewIndex].tile}
              draggable="false"
              onClick={() => setState({tooltipTile: false})}
              alt="tile"
              />
            </Tooltip>
          </div>
          
        </div>
        </Draggable>
        
        <Draggable {...dragHandlers} position={state.controlledPositionI} onStop={onControlledDragStopI} > 
          <div style={{ position: 'absolute', zIndex: '6',}}>
            <div className={styles.reactdraggable} style={{ filter: 'drop-shadow(20px 20px 4px rgba(50, 50, 50, .3))'}} >
            <Tooltip 
            title={materialSel.name[5]} 
            placement="left"
            disableFocusListener 
            disableTouchListener
            >

              <img 
              src={materialSel.valkey[5]}  
              style={boardStyles[viewIndex].industrial}
              
              draggable="false"
              onClick={() => setState({tooltipIndustry: false})}
              alt="industrial"
              />
            </Tooltip>
              
            </div>
            
          </div>
        </Draggable> 
        </div>
        {/* <div id='radioBoard' style={{top: '94%', width: `${boardWidth*.3}px`,  */}
        <div id='radioBoard' style={{top: '94%', width: `15rem`, 
            display: 'flex', 
            alignItems: 'flex-end', 
            // marginLeft: '40%', 
            marginLeft: '35%', 
            position: 'absolute', 
            zIndex: '10'}}>
            {/* <CustomizedRadios setViewIndex={setViewIndex} positionCallback={zprimposition}/> */}
            <CustomizedRadios setViewIndex={setViewIndex} />
          </div>
        </div>
      );
    }


export default Board;